module.exports = __webpack_public_path__ + "static/img/jp_icon01.7f56bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/jp_icon01.png
// module id = ETYa
// module chunks = 6